export default "__VITE_ASSET__B8NQN13y__"